import React from 'react';
import './ComingSoon.scss';

const ComingSoon = () => {
    return (
        <div className="coming-soon-container">
            <div className="content">
                <h1>Something New is Coming</h1>
                <p>We’re cooking up something exciting! Stay tuned.</p>
            </div>
        </div>
    );
};

export default ComingSoon;
